import React, { createContext, useContext, useState } from "react";

const translations = {
  en: {
    "nav.home": "Home",
    "nav.coffee": "Our Coffee",
    "nav.stock": "Available Stock",
    "nav.warehouse": "Our Warehouse",
    "nav.journey": "Export Journey",
    "nav.quality": "Quality",
    "nav.origin": "Coffee Origin",
    "nav.logistics": "Export & Logistics",
    "nav.gallery": "Gallery",
    "nav.about": "About Us",
    "nav.contact": "Contact",
    "cta.quote": "Request a Quote",
    "cta.stock": "View Available Stock",
    "cta.sample": "Request a Sample",
    "cta.whatsapp": "WhatsApp Us",
    "cta.contact": "Contact Our Team",
    "cta.specs": "View Specifications",
    "cta.catalog": "Download Catalog",
    "hero.title1": "Indonesian Arabica Green Coffee,",
    "hero.title2": "Ready for Global Buyers.",
    "hero.sub": "Reliable supply of Indonesian Arabica green beans, carefully sourced, quality-controlled, stored and prepared for international shipment.",
    "hero.trust": "Established 2020 • Indonesian Origin • Green Coffee Supplier & Exporter",
    "trust.title": "Built Around Reliable Supply",
    "trust.sub": "Warehouse Coffee focuses on sourcing, storing, quality control and preparing Indonesian Arabica green coffee for international buyers.",
    "stock.title": "Available Green Coffee Stock",
    "stock.sub": "Current coffee availability from our warehouse and sourcing network.",
    "stock.empty": "Stock information is currently being updated. Please contact our team for current availability.",
    "stock.lastUpdated": "Last Updated",
    "stock.sheetTitle": "Stock & Price Sheet",
    "stock.sheetSub": "Download the current stock list with full specifications. Prices are quoted on request.",
    "stock.downloadPdf": "Download PDF",
    "stock.downloadExcel": "Download Excel",
    "share.whatsapp": "Share on WhatsApp",
    "share.copy": "Copy link",
    "share.copied": "Link copied",
    "share.product": "Share this coffee",
    "share.priceSheetText": "Warehouse Coffee - latest Indonesian green coffee stock & price sheet:",
    "share.productText": "Indonesian green coffee from Warehouse Coffee:",
    "common.viewProduct": "View Details",
    "common.loading": "Loading...",
    "gallery.empty": "Company gallery will be updated soon.",
    "photos.empty": "Real photos are being updated shortly. Please contact our team for more information.",
    "footer.rights": "All rights reserved.",
    "quote.thanks": "Thank you. Your inquiry has been received. Our team will review your requirements and contact you.",
  },
  id: {
    "nav.home": "Beranda",
    "nav.coffee": "Kopi Kami",
    "nav.stock": "Stok Tersedia",
    "nav.warehouse": "Gudang Kami",
    "nav.journey": "Perjalanan Ekspor",
    "nav.quality": "Kualitas",
    "nav.origin": "Asal Kopi",
    "nav.logistics": "Ekspor & Logistik",
    "nav.gallery": "Galeri",
    "nav.about": "Tentang Kami",
    "nav.contact": "Kontak",
    "cta.quote": "Minta Penawaran",
    "cta.stock": "Lihat Stok Tersedia",
    "cta.sample": "Minta Sampel",
    "cta.whatsapp": "Hubungi WhatsApp",
    "cta.contact": "Hubungi Tim Kami",
    "cta.specs": "Lihat Spesifikasi",
    "cta.catalog": "Unduh Katalog",
    "hero.title1": "Kopi Hijau Arabika Indonesia,",
    "hero.title2": "Siap untuk Pembeli Global.",
    "hero.sub": "Pasokan andal biji hijau Arabika Indonesia, dipilih dengan cermat, dikontrol kualitasnya, disimpan dan disiapkan untuk pengiriman internasional.",
    "hero.trust": "Berdiri 2020 • Asal Indonesia • Pemasok & Eksportir Kopi Hijau",
    "trust.title": "Dibangun di Atas Pasokan yang Andal",
    "trust.sub": "Warehouse Coffee berfokus pada sumber, penyimpanan, kontrol kualitas dan penyiapan kopi hijau Arabika Indonesia untuk pembeli internasional.",
    "stock.title": "Stok Kopi Hijau Tersedia",
    "stock.sub": "Ketersediaan kopi saat ini dari gudang dan jaringan sumber kami.",
    "stock.empty": "Informasi stok sedang diperbarui. Silakan hubungi tim kami untuk ketersediaan terkini.",
    "stock.lastUpdated": "Terakhir Diperbarui",
    "stock.sheetTitle": "Daftar Stok & Harga",
    "stock.sheetSub": "Unduh daftar stok terkini lengkap dengan spesifikasi. Harga tersedia atas permintaan.",
    "stock.downloadPdf": "Unduh PDF",
    "stock.downloadExcel": "Unduh Excel",
    "share.whatsapp": "Bagikan via WhatsApp",
    "share.copy": "Salin tautan",
    "share.copied": "Tautan disalin",
    "share.product": "Bagikan kopi ini",
    "share.priceSheetText": "Warehouse Coffee - daftar stok & harga kopi hijau Indonesia terbaru:",
    "share.productText": "Kopi hijau Indonesia dari Warehouse Coffee:",
    "common.viewProduct": "Lihat Detail",
    "common.loading": "Memuat...",
    "gallery.empty": "Galeri perusahaan akan segera diperbarui.",
    "photos.empty": "Foto asli sedang diperbarui. Silakan hubungi tim kami untuk informasi lebih lanjut.",
    "footer.rights": "Hak cipta dilindungi.",
    "quote.thanks": "Terima kasih. Permintaan Anda telah kami terima. Tim kami akan meninjau kebutuhan Anda dan menghubungi Anda.",
  },
};

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(localStorage.getItem("wc_lang") || "en");
  const changeLang = (l) => { setLang(l); localStorage.setItem("wc_lang", l); };
  const t = (key) => translations[lang]?.[key] ?? translations.en[key] ?? key;
  return (
    <LangContext.Provider value={{ lang, changeLang, t }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
